<template>
    <div id="sidebar-main" class="sidebar-wrapper">
        <div id="nav-wrapper" v-if="init">
            <a href="#"
               id="nav-toggle"
               class="collapsed"
               :title="navIsExpanded ? 'Click to hide' : 'Click to expand'"
               v-on:click.prevent="commitMutation('toggleSidebar')">
                <span class="bar"></span>
            </a>

            <template v-if="(accountInvite && accountInvite.logo_url) || (!accountInvite && init.auth_user.company.logo_url)">
                <div id="nav-header">
                    <div id="company-logo">
                        <template v-if="accountInvite">
                            <img :src="accountInvite.logo_url" :alt="accountInvite.company" />
                        </template>
                        <template v-else>
                            <img :src="init.auth_user.company.logo_url" :alt="init.auth_user.company.name" />
                        </template>
                    </div>
                    <div class="powered-by"><span>Powered By</span></div>
                </div>
            </template>

            <nav id="nav">
                <router-link to="/" :title="title" exact>
                    <logo />
                </router-link>
                <div class="nav-widget" v-if="init.auth_user.via_share_link">
                    <h6>Welcome!</h6>
                    <p>Interested in reconciling and organizing your submission data like this?</p>
                    <p>Let us show you how.</p>
                    <br />
                    <p><strong>Griptiller, LLC</strong></p>
                    <p><a href="tel:+16174097500">617-409-7500</a></p>
                    <p><a href="mailto:admin@griptiller.com">admin@griptiller.com</a></p>
                </div>
                <nav-link v-on:click.native="logout" to="login" label="Login" icon="sign-in-alt" v-if="init.auth_user.via_share_link"></nav-link>
                <a href="#"
                   class="nav-item"
                   v-on:click="commitMutation('toggleGlobalSearch')"
                   v-if="userCan('view_global_search', 'init')">
                    <span class="nav-icon">
                        <i class="fas fa-search"></i>
                    </span>
                    <span class="nav-label">Global Search</span>
                </a>
                <nav-link to="dashboard" label="Dashboard" icon="tachometer-alt" v-if="userCan('view_dashboard_component', 'init')"></nav-link>
                <nav-link to="accounts" label="Accounts" icon="briefcase" v-if="userCan('view_accounts_component', 'init')"></nav-link>
                <nav-link to="companies" label="Companies" icon="building" v-if="userCan('view_companies_component', 'init')"></nav-link>
                <nav-link to="users" label="Users" icon="users" v-if="userCan('view_users_component', 'init')"></nav-link>
                <nav-link to="subscriptions" label="Subscriptions" icon="coins" v-if="userCan('view_subscriptions_component', 'init')"></nav-link>
                <nav-link to="roles" label="Roles" icon="users-cog" v-if="userCan('view_roles_component', 'init')"></nav-link>
            </nav>

            <nav id="nav-user" v-if="!init.auth_user.via_share_link">
                <div id="subscription" class="is-hidden-mobile" v-if="init.auth_user.subscription">
                    <router-link :to="{name: 'settings'}" title="Subscription" class="button">
                        {{ init.auth_user.subscription.name }}
                    </router-link>
                </div>
                <nav>
                    <nav-link to="settings" label="Settings" icon="cogs" />
                    <nav-link to="profile" label="My Profile" icon="user" />
                    <button title="Logout"
                            class="nav-item"
                            v-on:click.prevent="logout">
                        <span class="nav-icon">
                            <i class="fas fa-sign-out-alt"></i>
                        </span>
                        <span class="nav-label">Logout</span>
                    </button>
                </nav>
            </nav>
        </div>
    </div>
</template>

<script>
import Logo from '../Icons/Logo'
import NavLink from './Link'
import { mapGetters, mapState } from 'vuex'
import { AUTH_LOGOUT } from '../../store/actions/auth'

export default {
  name: 'Sidebar',
  components: {
    'logo': Logo,
    'nav-link': NavLink
  },
  data () {
    return {
      title: process.env.NAME
    }
  },
  computed: {
    ...mapState({
      navIsExpanded: state => state.navIsExpanded
    }),
    ...mapGetters({
      init: 'init',
      pusher: 'pusher/init',
      userCan: 'userCan',
      totalFlags: 'flags/total',
      accountInvite: 'accountInvite'
    }),
    userId: function () {
      return this.init.auth_user.id
    },
    pusherChannel: function () {
      if (!this.pusher) return
      return this.pusher.subscribe('private-user.' + this.userId + '.notifications')
    }
  },
  methods: {
    commitMutation (mutation) {
      this.$store.commit(mutation)
    },
    logout: function () {
      if (this.pusherChannel && this.pusher) {
        this.pusherChannel.unbind()

        this.pusher.allChannels()
          .forEach(channel => this.pusher.unsubscribe(channel.name))
      }

      this.$store.dispatch(AUTH_LOGOUT)
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Nav/Sidebar.vue